import appearAnimation from './appear'

export default {
	mixins: [appearAnimation],
	watch: {
		'$store.getters.isLoading'(value) {
			if (!value) {
				if (!this.appearTl) {
					this.buildAppearTl()
				}
				this.appearTl.play()
			}
		},
	},
}
